import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { ShelfBlock } from './ShelfBlock';
import { hwApi, iclApi } from '../../api';
import decorIconSubjectGirl from '../../assets/img/icon-girl-book.png';
import { getFuncNotebooks, getMaterialsStudent, subjectsObj, getSubjectsStudentSelector } from '../../Common/Database';
import Pagination from '../../Components/Pagination';

import './style.scss';
const itemsPerShelf = 3;
const itemsPerDesktopPage = 6;

const StudentMaterials = ({ mail }) => {
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [items, setItems] = useState([]);
  const [itemsMobile, setItemsMobile] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [studentSubjectObj, setStudentSubjectObj] = useState({});
  const [newIcls, setNewIcls] = useState([]);
  const [hws, setHws] = useState([]);
  const [exams, setExams] = useState([]);
  const params = useParams();

  const getNotebooks = mail => {
    try {
      getFuncNotebooks(mail)
        .then(res => {
          setData(res);
        })
        .catch(error => {
          console.log('getNotebooks');
        });
    } catch (error) {
      console.log('getNotebooks');
      setData({});
    }
  };

  const getMaterials = mail => {
    try {
      getMaterialsStudent(mail).then(res => {
        setData(res);
      });
    } catch (error) {
      setData({});
    }
  };

  const getFullMaterials = mail => {
    try {
      getMaterialsStudent(mail).then(res => {
        getFuncNotebooks(mail).then(resNotebooks => {
          const filteredArr = Object.values(res).filter(item => subjectsObj[item.subject] == params.subject);
          const objNotebook = {
            item: resNotebooks[params.subject],
          };
          const obj = Object.assign({}, { ...filteredArr }, objNotebook);
          setData(obj);
        });
      });
    } catch (error) {
      setData({});
    }
  };

  useEffect(() => {
    const updateNewIcls = icls => setNewIcls(icls);
    const unsubscribe = iclApi.subscribeToStudentICLs({ setNewICLs: updateNewIcls, studentEmail: mail });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const setData = data => setHws(data);
    const unsubscribe = hwApi.subscribeToStudentHWs({ setNewHWs: setData, studentEmail: mail });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const setData = data => setExams(data);
    const unsubscribe = iclApi.subscribeToStudentExams({ setNewICLs: setData, studentEmail: mail });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (params.nameItem == 'notebooks' && data !== null && Object.keys(data).length !== 0) {
      const keys = Object.keys(data).filter((item, i) => {
        if (studentSubjectObj[item].activeSub) {
          return item;
        }
      });

      const result = keys.reduce((acc, key, index) => {
        const item = { itemName: 'notebook', subject: key };

        const lastIndex = acc.length - 1;
        if (index % 3 === 0) {
          acc.push([item]);
        } else {
          acc[lastIndex].push(item);
        }

        return acc;
      }, []);

      const resultMobile = keys.reduce((acc, key, index) => {
        const item = { itemName: 'notebook', subject: key };

        const lastIndex = acc.length - 1;
        if (index % 2 === 0) {
          acc.push([item]);
        } else {
          acc[lastIndex].push(item);
        }

        return acc;
      }, []);

      setItems(result);
      setItemsMobile(resultMobile);
    } else {
      setItems([]);
      setItemsMobile([]);
    }

    if (params.nameItem == 'books' && data !== null && Object.keys(data).length !== 0) {
      const values = Object.values(data ? data : {});
      const filtValues = values.filter((item, i) => {
        const subjectKey = subjectsObj[item.subject];
        const studentSubject = studentSubjectObj[subjectKey];

        if (!subjectKey) {
          return false;
        }

        if (!studentSubject) {
          return false;
        }

        if (typeof studentSubject.activeSub === 'undefined') {
          return false;
        }

        if (item.type === 'Book' && studentSubject.activeSub) {
          return true;
        }

        return false;
      });
      const result = filtValues.reduce((acc, key, index) => {
        const item = { itemName: key.type, subject: key };

        const lastIndex = acc.length - 1;
        if (index % 3 === 0) {
          acc.push([item]);
        } else {
          acc[lastIndex].push(item);
        }
        return acc;
      }, []);

      const resultMobile = filtValues.reduce((acc, key, index) => {
        const item = { itemName: key.type, subject: key };

        const lastIndex = acc.length - 1;
        if (index % 2 === 0) {
          acc.push([item]);
        } else {
          acc[lastIndex].push(item);
        }

        return acc;
      }, []);

      setItems(result);
      setItemsMobile(resultMobile);
    }

    if (params.nameItem == 'materials' && data !== null && Object.keys(data).length !== 0) {
      const values = Object.values(data ? data : {});
      const result = values.reduce((acc, key, index) => {
        const item = {
          itemName: key.type ? key.type : 'notebook',
          subject: key,
        };

        const lastIndex = acc.length - 1;
        if (index % 3 === 0) {
          acc.push([item]);
        } else {
          acc[lastIndex].push(item);
        }
        return acc;
      }, []);

      const resultMobile = values.reduce((acc, key, index) => {
        const item = {
          itemName: key.type ? key.type : 'notebook',
          subject: key,
        };

        const lastIndex = acc.length - 1;
        if (index % 2 === 0) {
          acc.push([item]);
        } else {
          acc[lastIndex].push(item);
        }

        return acc;
      }, []);

      setItems(result);
      setItemsMobile(resultMobile);
    }
  }, [data, studentSubjectObj]);

  useEffect(() => {
    setStudentSubjectObj(getSubjectsStudentSelector());

    switch (params.nameItem) {
      case 'notebooks':
        getNotebooks(mail);
        break;
      case 'exams':
      case 'books':
      case 'exams-tab':
        getMaterials(mail);
        break;
      case 'materials':
        getFullMaterials(mail);
        break;

      default:
        break;
    }
  }, []);

  const chooseItems = type => {
    let result = [];

    if (type === 'exams') {
      result = newIcls.map(icl => ({ ...icl, nameItem: 'icl' }));
    }

    if (type === 'exams-tab') {
      result = exams.map(icl => ({ ...icl, nameItem: 'exam' }));
    }

    if (type === 'homeworks') {
      result = hws.map(icl => ({ ...icl, nameItem: 'hw' }));
    }

    if (type === 'books') {
      result = items.flat().map(item => ({ ...item.subject, nameItem: 'Book' }));
    }

    if (type !== 'exams' && type !== 'homeworks' && type !== 'books' && type !== 'exams-tab') {
      result = items;
    }

    return result;
  };

  const getPageItems = (page, type, itemsPerPage) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return {
      firstShelf: chooseItems(type).slice(startIndex, endIndex - itemsPerShelf) || [],
      secondShelf: chooseItems(type).slice(startIndex + itemsPerShelf, endIndex) || [],
    };
  };

  const desktopItems = getPageItems(currentPage, params.nameItem, itemsPerDesktopPage);
  const mobileItems = [...desktopItems.firstShelf, ...desktopItems.secondShelf];

  return (
    <div className="student-materilas-page container">
      <div className="title-wrap">
        <h1>{t(params.nameItem)}</h1>
      </div>

      <div className="student-materilas-shelf mb-20">
        <div className="decor-item-img">
          <img src={decorIconSubjectGirl} alt="decor-icon" />
        </div>

        <div className="shelf-block">
          {desktopItems.firstShelf.length > 0 && (
            <ShelfBlock items={desktopItems.firstShelf} mail={mail} nameItem={params.nameItem} />
          )}
          {desktopItems.secondShelf.length > 0 && (
            <ShelfBlock items={desktopItems.secondShelf} mail={mail} nameItem={params.nameItem} />
          )}

          {desktopItems.firstShelf.length === 0 && <ShelfBlock />}
          {desktopItems.secondShelf.length === 0 && <ShelfBlock />}

          {chooseItems(params.nameItem).length > itemsPerDesktopPage && (
            <div className="pagination-wrap">
              <Pagination
                totalItems={chooseItems(params.nameItem).length}
                itemsPerPage={itemsPerDesktopPage}
                onPaginate={setCurrentPage}
              />
            </div>
          )}
        </div>

        <div className="shelf-block shelf-block-mobile">
          {mobileItems.length > 0 &&
            mobileItems.map(item => <ShelfBlock key={item.id} items={[item]} mail={mail} nameItem={params.nameItem} />)}

          {mobileItems.length === 0 && (
            <>
              <ShelfBlock />
              <ShelfBlock />
            </>
          )}

          {mobileItems.length === 1 && <ShelfBlock />}

          {chooseItems(params.nameItem).length > itemsPerDesktopPage && (
            <div className="pagination-wrap">
              <Pagination
                totalItems={chooseItems(params.nameItem).length}
                itemsPerPage={itemsPerDesktopPage}
                onPaginate={setCurrentPage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentMaterials;
